// The keyboard shortcut overlay (press ?), rendered from the shortcut map.
import type { Editor } from '../editor.ts';
import { displayKeys, SHORTCUTS, type ShortcutGroup } from '../keyboard.ts';
import { h } from '../util/dom.ts';

const GROUPS: ShortcutGroup[] = ['Tools', 'Edit', 'Arrange', 'View', 'Text'];

export function openShortcutHelp(): void {
  if (document.querySelector('.dialog.help')) return;
  const sections = GROUPS.map((g) => h('section', {}, [
    h('h3', {}, [g]),
    h('dl', { class: 'keys' }, SHORTCUTS.filter((s) => s.group === g && !s.hidden).flatMap((s) => [
      h('dt', {}, [s.label]),
      h('dd', {}, displayKeys(s).map((k) => h('kbd', {}, [k]))),
    ])),
  ]));
  const close = h('button', { type: 'button', class: 'btn' }, ['Close']);
  const dialog = h('dialog', { class: 'dialog help', 'aria-labelledby': 'help-title' }, [
    h('h2', { id: 'help-title' }, ['Keyboard shortcuts']),
    h('div', { class: 'help-grid' }, sections),
    h('div', { class: 'dialog-actions' }, [close]),
  ]);
  close.addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => dialog.remove());
  document.body.append(dialog);
  dialog.showModal();
}

export function bindShortcutHelp(ed: Editor): void {
  ed.events.on('command', (c) => { if (c === 'shortcuts') openShortcutHelp(); });
}
